import type {LiveTranscriptionOperationType} from "react-native-zoom-video-sdk";

export type ZoomVideoSdkLiveTranscriptionMessageInfoType = {
    /**
     * ID of the transcription message.
     */
    messageID: string;

    /**
     * Content of the transcription message.
     */
    messageContent: string;

    /**
     * Type of transcription message.
     */
    messageType: LiveTranscriptionOperationType;

    /**
     * Speaker name of the transcription message.
     */
    speakerName: string;

    /**
     * Speaker ID of the transcription message.
     */
    speakerID: string;

    /**
     * Time stamp of the transcription message.
     */
    timeStamp: string;
};

export class ZoomVideoSdkLiveTranscriptionMessageInfo implements ZoomVideoSdkLiveTranscriptionMessageInfoType
{
    messageID;
    messageContent;
    messageType;
    speakerName;
    speakerID;
    timeStamp;

    constructor(messageInfo: ZoomVideoSdkLiveTranscriptionMessageInfoType) {
        this.messageID = messageInfo.messageID;
        this.messageContent = messageInfo.messageContent;
        this.messageType = messageInfo.messageType;
        this.speakerName = messageInfo.speakerName;
        this.speakerID = messageInfo.speakerID;
        this.timeStamp = messageInfo.timeStamp;
    }
}
